<template>
	<router-link
		tag="div"
		class="event-card"
		@click.native="eventClicked"
		:class="{ upcoming: isUpcoming }"
		:to="`/${slug}/menu/event/${event.id}`"
	>
		<div class="upcoming-event-image" :style="eventBannerStyle">
			<div
				v-if="isInPreorderStatus"
				class="pill pill-dark-navy last-call-pill"
			>
				Last Call
				<b>{{ lastCall }}</b>
			</div>
			<div v-else class="pill pill-dark-navy last-call-pill">Ongoing</div>
		</div>
		<div class="upcoming-event-details">
			<div class="event-date-pill">
				<div>{{ eventMonth }}</div>
				<b>{{ eventDay }}</b>
			</div>
			<div>
				<h2>{{ event.name }}</h2>
				<div v-if="isInPreorderStatus" class="event-time">
					{{ eventTime }}
				</div>
				<div v-else class="event-time">Ongoing</div>
			</div>
		</div>
	</router-link>
</template>

<style scoped>
.event-card {
	cursor: pointer;
	background-size: cover;
	background-position: center;
	margin-top: 15px !important;
	margin-bottom: 15px !important;
}

.event-card.upcoming .upcoming-event-image {
	height: 195px;
}

.upcoming-event-image {
	width: 100%;
	height: 160px;
	border-radius: 5px;
	position: relative;
	margin-bottom: 10px;
}

.upcoming-event-details {
	display: flex;
	align-items: center;
}

h2 {
	margin-bottom: 4px;
	font-size: 14px;
	font-weight: 600;
	color: var(--gR-base-80);
}

.upcoming-event-details .event-time {
	font-size: 12px;
	color: var(--sk-grey3);
}
</style>

<script>
import eventDetailsMixin from "@/mixins/event-details-mixin"

export default {
	name: "EventCard",
	mixins: [eventDetailsMixin],
	props: {
		event: Object,
		isUpcoming: {
			default: false,
			type: Boolean
		}
	},
	computed: {
		slug() {
			return this.$route.params.slug
		}
	},
	methods: {
		eventClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Event Clicked",
				data: {
					content: "Upcoming Events"
				}
			})
		}
	}
}
</script>